module.exports = __webpack_public_path__ + "53c1f4b6b1fdadd2f7f2f0272ee98e53.png";